import { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import QuoteSection from '../components/QuoteSection';
import LightboxModal from '../components/LightboxModal';
import { companyInfo } from '../data/siteData';
import { imageUrl } from '../lib/images';

export default function FoldeportePage() {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const images = [
    { src: "/_assets/thumbnail-img20250417120146.jpg", title: "Foldeport i indkørsel" },
    { src: "/_assets/thumbnail-img20250512145254.jpg", title: "Foldeport lukket" },
    { src: "/_assets/thumbnail-img20250512145308_93c3efd6.jpg", title: "Foldeport åbnet" },
  ];

  return (
    <>
      <SEO
        title="Foldeporte i funktionelt design | Hovendals"
        description="Foldeporte i høj kvalitet En foldeport er en praktisk og pladsbesparende løsning, der giver nem adgang til din indkørsel eller dit hegn. Hos Hovendal leverer vi foldeporte i høj kvalitet, tilpasset dine mål og dit designønske. Resultatet er en solid, funktionel og æstetisk port, der holder i mange år Fordele ved foldeporte"
        ogImage="/_assets/shutterstock-1933153790.jpg"
      />

      {/* Hero */}
      <section className="relative py-20 bg-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={imageUrl("/_assets/shutterstock-1933153790.jpg", "width=1600,quality=80,format=auto")}
            alt="Foldeporte i funktionelt design"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl space-y-4">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider bg-[#004fa4]/20 text-[#c2ccdf] border border-[#004fa4]/30">
              <i className="fa-sharp fa-solid fa-arrows-split-up-and-left" aria-hidden="true"></i>
              <span>Pladsbesparende</span>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-tight">
              Foldeporte i funktionelt design
            </h1>
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal">
              Praktisk og pladsbesparende løsning, der giver nem adgang til din indkørsel eller dit hegn.
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="space-y-6">
              <div>
                <span className="text-xs font-bold uppercase tracking-wider text-[#004fa4]">Pladsbesparende adgang</span>
                <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight mt-1">
                  Foldeporte i høj kvalitet
                </h2>
              </div>
              <p className="text-slate-700 leading-relaxed text-base">
                En foldeport er en praktisk og pladsbesparende løsning, der giver nem adgang til din indkørsel eller dit hegn. Hos Hovendal leverer vi foldeporte i høj kvalitet, tilpasset dine mål og dit designønske. Resultatet er en solid, funktionel og æstetisk port, der holder i mange år
              </p>

              <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
                <h3 className="font-bold text-slate-900 text-base mb-3">
                  Fordele ved foldeporte:
                </h3>
                <ul className="space-y-2.5 text-sm text-slate-700 font-medium">
                  <li className="flex items-start gap-2.5">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Pladsbesparende løsning – perfekt til små områder</span>
                  </li>
                  <li className="flex items-start gap-2.5">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Nem og hurtig adgang til indkørsel eller have</span>
                  </li>
                  <li className="flex items-start gap-2.5">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Kan tilpasses i både mål og design</span>
                  </li>
                  <li className="flex items-start gap-2.5">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Robust kvalitet, der holder i mange år</span>
                  </li>
                  <li className="flex items-start gap-2.5">
                    <i className="fa-sharp fa-solid fa-check text-[#004fa4] mt-1" aria-hidden="true"></i>
                    <span>Kombinerer funktionalitet med flot udtryk</span>
                  </li>
                </ul>
              </div>

              <div className="flex flex-wrap gap-4 pt-2">
                <a
                  href={`tel:${companyInfo.phoneFormatted}`}
                  className="px-6 py-3 rounded-lg bg-[#004fa4] hover:bg-[#183e7f] text-white font-medium text-sm shadow-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
                  <span>Ring: {companyInfo.phone}</span>
                </a>
                <Link
                  to="/kontakt"
                  className="px-6 py-3 rounded-lg bg-slate-900 hover:bg-slate-800 text-white font-bold text-sm transition-all flex items-center gap-2"
                >
                  <i className="fa-sharp fa-solid fa-paper-plane" aria-hidden="true"></i>
                  <span>Få et uforpligtende tilbud</span>
                </Link>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl border-4 border-white bg-slate-100">
              <img
                src={imageUrl("/_assets/foldeport.webp", "width=1200,quality=85,format=auto")}
                alt="Bred foldeport i træ og stål ved privat ejendom"
                className="w-full h-auto aspect-[16/10] object-cover"
              />
            </div>
          </div>

          {/* Galleri */}
          <div className="mb-16">
            <h3 className="text-2xl font-bold text-slate-900 mb-2">
              Billeder af foldeporte
            </h3>
            <p className="text-sm text-slate-600 mb-6">
              Klik på et billede for at se forstørret version.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl">
              {images.map((img, idx) => (
                <div
                  key={idx}
                  onClick={() => setLightboxIndex(idx)}
                  className="group relative h-64 rounded-xl overflow-hidden bg-slate-100 cursor-pointer shadow-sm hover:shadow-md transition-all"
                >
                  <img
                    src={imageUrl(img.src, "width=600,quality=80,format=auto")}
                    alt={img.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-slate-950/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center text-white">
                    <span className="p-2.5 rounded-full bg-[#143463]/90 text-white text-sm">
                      <i className="fa-sharp fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Quote Section */}
      <QuoteSection />

      {/* Lightbox modal */}
      <LightboxModal
        images={images}
        currentIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        onNavigate={(index) => setLightboxIndex(index)}
      />
    </>
  );
}
